import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from '../ValidationElement';
import NumberComponent from '../Number';
import { setAttribute } from '../shared/setAttribute';

export default class Height extends ValidationElement {
  constructor(props) {
    super(props);

    this.state = {
      uid: `${this.props.name}-${super.guid()}`,
      feet: props.feet,
      inches: props.inches,
      error: props.error,
      valid: props.valid,
      errors: [],
    };

    this.handleError = this.handleError.bind(this);
    this.handleErrorFeet = this.handleErrorFeet.bind(this);
    this.handleErrorInches = this.handleErrorInches.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);

    this.feet = React.createRef();
    this.inches = React.createRef();
  }

  /**
   * Handle the change event.
   */
  handleChange(field, event) {
    this.setState({ [field]: event.target.value }, () => {
      super.handleChange(event);
      if (this.props.onUpdate) {
        this.props.onUpdate({
          feet: this.state.feet,
          inches: this.state.inches,
        });
      }
    });
  }

  handleErrorFeet(value, arr) {
    return this.handleError('feet', value, arr);
  }

  handleErrorInches(value, arr) {
    return this.handleError('inches', value, arr);
  }

  handleError(code, value, arr) {
    const arr2 = arr.map((err) => ({
      code: `height.${code}.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    const requiredErrors = arr2.concat(
      this.constructor.errors.map((err) => ({
        code: `height.${err.code}`,
        valid: err.func({ ...this.state }, this.props),
        uid: this.state.uid,
      }))
    );

    // Take the original and concatenate our new error values to it
    this.props.onError(value, requiredErrors);
    return arr2;
  }

  /**
   * Handle the focus event.
   */
  handleFocus(event) {
    this.setState({ focus: true }, () => {
      super.handleFocus(event);
    });
  }

  /**
   * Handle the blur event.
   */
  handleBlur(event) {
    this.setState({ focus: false }, () => {
      super.handleBlur(event);
    });
  }

  /**
   * Generated name for the part of the address elements.
   */
  partName(part) {
    return `${this.props.name}-${part}`;
  }

  render() {
    const feetChange = this.handleChange.bind(this, 'feet');
    const inchesChange = this.handleChange.bind(this, 'inches');
    return (
      <div className="height">
        <div className="feet">
          <NumberComponent
            attribute={setAttribute(this.props.attribute, 'feet')}
            id={this.partName('feet')}
            name="feet"
            ref={this.feet}
            label={i18n.t('identification.traits.label.feet')}
            disabled={this.props.disabled}
            max="9"
            maxlength="1"
            min="1"
            readonly={this.props.readonly}
            required={this.props.required}
            step="1"
            value={this.state.feet}
            onChange={feetChange} // eslint-disable-line react/jsx-no-bind
            onFocus={this.handleFocus} // eslint-disable-line @typescript-eslint/unbound-method
            onBlur={this.handleBlur} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleErrorFeet} // eslint-disable-line @typescript-eslint/unbound-method
            tabNext={() => {
              this.props.tab(this.inches.current.number.current.input.current);
            }}
          />
        </div>
        <div className="inches">
          <NumberComponent
            attribute={setAttribute(this.props.attribute, 'inches')}
            id={this.partName('inches')}
            name="inches"
            ref={this.inches}
            label={i18n.t('identification.traits.label.inches')}
            disabled={this.props.disabled}
            max="11"
            maxlength="2"
            min="0"
            readonly={this.props.readonly}
            required={this.props.required}
            step="1"
            value={this.state.inches}
            onChange={inchesChange} // eslint-disable-line react/jsx-no-bind
            onFocus={this.handleFocus} // eslint-disable-line @typescript-eslint/unbound-method
            onBlur={this.handleBlur} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleErrorInches} // eslint-disable-line @typescript-eslint/unbound-method
            tabBack={() => {
              this.props.tab(this.feet.current.number.current.input.current);
            }}
          />
        </div>
      </div>
    );
  }
}

Height.defaultProps = {
  feet: '',
  inches: '',
  error: false,
  valid: false,
  tab: (input) => {
    input.focus();
  },
  onError: (value, arr) => arr,
  required: false,
};

Height.errors = [
  {
    code: 'required',
    func: (value, props) => {
      if (props.required) {
        return !!value.feet && !!value.inches;
      }
      return true;
    },
  },
];
